/* global axios */
import ApiClient from './ApiClient';

export class TransactionsAPI extends ApiClient {
  constructor() {
    super('transactions', { accountScoped: true });
  }

  fetchTransactionSummary(params={}) {
    return axios.get(`${this.url}/summary`, {
      params: {...params},
    });
  }
  fetchTransactionList(params={}) {
    return axios.get(`${this.url}`, {
      params: {...params},
    });
  }

}

export default new TransactionsAPI();
